// Configuration for France (MyEcoCar)
import config from './conf.json';

export default config;